import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheChefProjetAgile = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧩 Recruter un Chef de Projet Agile
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Chef de Projet Agile pilote la réalisation de projets digitaux dans un cadre agile (Scrum, Kanban, SAFe…). Il agit comme un chef d’orchestre, coordonnant les équipes techniques, produit et métiers pour assurer la livraison des fonctionnalités dans le respect des délais, des budgets et des objectifs business. Il combine rigueur de gestion et agilité collaborative.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Cadrer les besoins métier et traduire les objectifs en backlog produit</li>
          <li>Organiser les sprints, prioriser les tâches et animer les points de suivi</li>
          <li>Gérer les risques, les arbitrages et la qualité des livrables</li>
          <li>Coordonner les équipes pluridisciplinaires (dev, QA, design, PO…)</li>
          <li>Suivre les KPIs projet et assurer le reporting client/stakeholders</li>
          <li>Conduire l’amélioration continue et la satisfaction client</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Méthodes : Scrum, Kanban, SAFe, Lean</li>
          <li>Outils : Jira, Trello, ClickUp, Notion, Confluence</li>
          <li>Gestion de planning, budget, risques et dépendances</li>
          <li>Capacité à faire le lien entre les enjeux métiers et les contraintes techniques</li>
          <li>Qualités humaines : leadership, organisation, pédagogie</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : soutien à un chef de projet sénior, gestion de petites features</li>
          <li>Confirmé : pilotage complet de projets digitaux en autonomie</li>
          <li>Senior : multi-projets, coordination d’équipes internationales, rôle stratégique</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–700 € / jour</li>
          <li>Senior : 750–950 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheChefProjetAgile;
